import {
  IOrganizationData,
  profileActions,
} from "@common/redux/profile/actions";
import {
  IProfileData,
  IProfileMap,
  IProfileReducerState,
} from "@common/redux/profile/interface";

export const initialState = {
  profileData: null,
  currentLoggedinUserprofileId: "",
  isLoggedInUserProfileCompleted: false,
  profileMap: {},
  organizationData: null,
  loaders: {
    userProfile: false,
    createProfile: false,
    updateProfile: false,
    deleteAddress: false,
    registerOrganization: false,
    fetchOrganization: false,
    updateOrganization: false,
  },
  errors: {
    userProfile: "",
    createProfile: "",
    updateProfile: "",
    deleteAddress: "",
    registerOrganization: "",
    fetchOrganization: "",
    updateOrganization: "",
  },
};

export const profileReducer = (
  state: IProfileReducerState = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case profileActions.CREATE_PROFILE:
      return {
        ...state,
        loaders: { ...state.loaders, createProfile: true },
        errors: { ...state.errors, createProfile: "" },
      };

    case profileActions.CREATE_PROFILE_SUCCESS:
      return {
        ...state,
        profileData: action.payload.profileData,
        loaders: { ...state.loaders, createProfile: false },
      };

    case profileActions.CREATE_PROFILE_FAILURE:
      return {
        ...state,
        loaders: { ...state.loaders, createProfile: false },
        errors: { ...state.errors, createProfile: action.payload },
      };

    case profileActions.FETCH_PROFILES:
      return {
        ...state,
        loaders: { ...state.loaders, userProfile: true },
        errors: { ...state.errors, userProfile: "" },
      };

    case profileActions.FETCH_PROFILES_SUCCESS:
      const profileMap: IProfileMap = { ...state.profileMap };

      action.payload.forEach((item, index) => {
        profileMap[item.userId] = item;
      });
      return {
        ...state,
        profileMap: profileMap,
        loaders: { ...state.loaders, userProfile: false },
      };


    case profileActions.SET_PROFILE_MAP:
      {
        const profileMap: IProfileMap = { ...state.profileMap };
        const updatedProfileMap = action.payload
        return {
          ...state,
          profileMap: { ...profileMap, ...updatedProfileMap },
        };
      }


    case profileActions.FETCH_PROFILES_FAILURE:
      return {
        ...state,
        loaders: { ...state.loaders, userProfile: false },
        errors: { ...state.errors, userProfile: action.payload },
      };

    case profileActions.UPDATE_PROFILE_DETAILS:
      return {
        ...state,
        loaders: { ...state.loaders, updateProfile: true },
        errors: { ...state.errors, updateProfile: "" },
      };

    case profileActions.UPDATE_PROFILE_DETAILS_SUCCESS: {
      const existingProfileMap = { ...state.profileMap };
      const updatedProfileData: IProfileData = action?.payload;
      let existingProfileData: IProfileData =
        existingProfileMap[updatedProfileData?.userId];
      if (existingProfileData) {
        existingProfileData = { ...existingProfileData, ...updatedProfileData };
      } else {
        existingProfileData = action?.payload;
      }
      existingProfileMap[action?.payload?.userId] = existingProfileData;
      return {
        ...state,
        profileMap: existingProfileMap,
        loaders: { ...state.loaders, updateProfile: false },
      };
    }
    case profileActions.UPDATE_PROFILE_DETAILS_FAILURE:
      return {
        ...state,
        loaders: { ...state.loaders, updateProfile: false },
        errors: { ...state.errors, updateProfile: action.payload },
      };

    case profileActions.DELETE_ADDRESS:
      return {
        ...state,
        loaders: { ...state.loaders, deleteAddress: true },
        errors: { ...state.errors, deleteAddress: "" },
      };

    case profileActions.DELETE_ADDRESS_SUCCESS:
      return {
        ...state,
        profileData: action.payload.profileData,
        loaders: { ...state.loaders, deleteAddress: false },
      };

    case profileActions.DELETE_ADDRESS_FAILURE:
      return {
        ...state,
        loaders: { ...state.loaders, deleteAddress: false },
        errors: { ...state.errors, deleteAddress: action.payload },
      };

    case profileActions.SET_PROFILE_IMAGE: {
      const { profileId, imageUrl } = action.payload;
      const existingProfileMap = { ...state.profileMap };
      const latestProfileData: IProfileData = existingProfileMap[profileId];
      latestProfileData.profilePicUrl = imageUrl;
      existingProfileMap[profileId] = latestProfileData;

      return {
        ...state,
        profileMap: existingProfileMap,
      };
    }
    case profileActions.SET_CURRENT_LOGGEDIN_USER_ID:
      return {
        ...state,
        currentLoggedinUserprofileId: action?.payload,
      };

    case profileActions.SET_IS_LOGGEDIN_USER_PROFILE_COMPLETED:
      return {
        ...state,
        isLoggedInUserProfileCompleted: action?.payload,
      };

    case profileActions.REGISTER_ORGANISATION:
      return {
        ...state,
        loaders: { ...state.loaders, registerOrganization: true },
        errors: { ...state.errors, registerOrganization: "" },
      };

    case profileActions.REGISTER_ORGANISATION_SUCCESS:
      return {
        ...state,
        organizationData: action.payload,
        loaders: { ...state.loaders, registerOrganization: false },
      };
    case profileActions.REGISTER_ORGANISATION_FAILURE:
      return {
        ...state,
        loaders: { ...state.loaders, registerOrganization: false },
        errors: { ...state.errors, registerOrganization: action.payload },
      };

    case profileActions.FETCH_ORGANIZATION:
      return {
        ...state,
        loaders: { ...state.loaders, fetchOrganization: true },
        errors: { ...state.errors, fetchOrganization: "" },
      };

    case profileActions.FETCH_ORGANIZATION_SUCCESS: {
      const organizationDatas: IOrganizationData[] = action?.payload?.content;
      let existingOrganizationData: IOrganizationData = {
        ...state?.organizationData,
      };
      organizationDatas.slice(0, 1).forEach((item) => {
        //user must have  only 1 organization details
        existingOrganizationData = item;
      });
      return {
        ...state,
        organizationData: existingOrganizationData,
        loaders: { ...state.loaders, fetchOrganization: false },
      };
    }
    case profileActions.FETCH_ORGANIZATION_FAILURE:
      return {
        ...state,
        loaders: { ...state.loaders, fetchOrganization: false },
        errors: { ...state.errors, fetchOrganization: action.payload },
      };

    case profileActions.UPDATE_ORGANISATION:
      return {
        ...state,
        loaders: { ...state.loaders, updateOrganization: true },
        errors: { ...state.errors, updateOrganization: "" },
      };

    case profileActions.UPDATE_ORGANISATION_SUCCESS: {
      const organizationData: IOrganizationData = action?.payload;
      return {
        ...state,
        organizationData,
        loaders: { ...state.loaders, updateOrganization: false },
      };
    }
    case profileActions.UPDATE_ORGANISATION_FAILURE:
      return {
        ...state,
        loaders: { ...state.loaders, updateOrganization: false },
        errors: { ...state.errors, updateOrganization: action.payload },
      };

    default:
      return { ...state };
  }
};
